<template>
  <div>
    <transition name="fade-grafico-vinculo" mode="out-in">
      <div v-if="!loading">
        <unicom-icone
          class="icone-grafico-vinculo"
          nome="pie-chart"
          :tamanho="25"
        />
        <div class="fonte-primaria" style="margin: 0px !important">
          <div id="container">
            <highcharts
              ref="grafico"
              :options="chartOptions"
              :callback="graficoCarregado"
            ></highcharts>
          </div>
        </div>
      </div>
      <CarregandoTipoVinculo v-if="loading" />
    </transition>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import CarregandoTipoVinculo from "./CarregandoTipoVinculo";
import GraficoMixin from "../GraficoMixin";

export default {
  components: {
    highcharts: Chart,
    CarregandoTipoVinculo
  },
  mixins: [GraficoMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    arrayGrafico: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    enumTipoRede() {
      return {
        COOPERADO: {
          color: "rgb(0,153,93)",
          corDesativada: "rgb(0,153,93,0.2)"
        },
        RECURSO_PROPRIO: {
          color: "rgb(177,211,75)",
          corDesativada: "rgb(177,211,75,0.2)"
        },
        CREDENCIADO: {
          color: "rgb(237,22,81)",
          corDesativada: "rgb(237,22,81,0.2)",
          name: "Credenciado"
        }
      };
    }
  },
  watch: {
    arrayGrafico: {
      deep: true,
      immediate: true,
      handler() {
        this.atualizarDados();
      }
    }
  },
  mounted() {
    // Dependendo da classe que o item tem, ele troca a cor do simbolo na legenda
    Highcharts.addEvent(Highcharts.Legend, "afterColorizeItem", e => {
      const nomeClasse = e.item.className;
      const contemClasseDesativada = nomeClasse === "point-vinculo-desativado";
      const contemClasseAtiva = nomeClasse === "point-vinculo-ativado";

      if (contemClasseDesativada) {
        e.item.legendSymbol.attr({
          fill: e.item.options.corDesativada
        });
      } else if (contemClasseAtiva) {
        e.item.legendSymbol.attr({
          fill: e.item.options.color
        });
      }
    });
  },
  methods: {
    atualizarDados() {
      // const total = this.arrayGrafico.reduce((acc, e) => acc + e.quantidade, 0);
      const dados = this.arrayGrafico.map(e => {
        const {
          quantidade,
          tipo: { chave, descricao }
        } = e;
        // let pcnt = (quantidade / total) * 100;

        // const porcentagemFormatado = Highcharts.numberFormat(pcnt, 0);

        return {
          y: quantidade === 0 ? null : quantidade,
          quantidade,
          name: descricao,
          ...this.enumTipoRede[chave],
          chave
        };
      });

      this.$set(this.chartOptions.series[0], "data", dados);
    },
    /**
     * Função que é chamada logo após o clique, tanto no gráfico quanto na legenda
     * @param { String } chave
     */
    selecionarChave(chave) {
      if (this.chaveSelecionada === chave && this.dadosDesativados) {
        this.$emit("remove-filtro", {
          chaveRemocao: "tipoVinculo",
          sucesso: () => this.ativarDados()
        });
        return;
      } else if (this.dadosDesativados) {
        return;
      }

      this.$emit("adiciona-filtro", {
        chaveAdicao: "tipoVinculo",
        value: chave,
        sucesso: () => this.desativarDados(chave)
      });
    },
    /**
     * Desativa todas as legendas e points que são diferentes da chave selecionada
     * @param { String } chave
     */
    desativarDados(chave) {
      this.dadosDesativados = true;
      this.chaveSelecionada = chave;

      this.graficoRef.series[0].data.forEach(e => {
        const { chave: chaveAtual } = e.options;
        if (chaveAtual !== chave) {
          e.update({ className: "point-vinculo-desativado" }, false);
        }
      });
      this.graficoRef.redraw();
    },
    /**
     * Ativa todas as legendas e points
     */
    ativarDados() {
      this.dadosDesativados = false;
      this.chaveSelecionada = null;

      this.graficoRef.series[0].data.forEach(e => {
        e.update({ className: "point-vinculo-ativado" }, false);
      });
      this.graficoRef.redraw();
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          renderTo: "container",
          type: "pie",
          height: "218px"
        },

        plotOptions: {
          pie: {
            size: "90%",
            innerSize: "100%",
            borderWidth: 5,
            allowPointSelect: true,
            cursor: "pointer"
          }
        },

        title: {
          text: "Tipo de vínculo",
          floating: true,
          align: "left",
          x: 40,
          style: {
            fontWeight: "bold",
            fontFamily: "Unimed Slab",
            color: "#60656C",
            fontSize: 21
          }
        },

        credits: {
          enabled: false
        },

        legend: {
          floating: true,
          width: 280,
          verticalAlign: "middle",
          itemStyle: {
            fontWeight: "normal",
            fontFamily: "Trebuchet MS",
            textAlign: "center",
            fontSize: 14
          },
          layout: "vertical",
          align: "left",
          symbolRadius: 4,
          itemMarginTop: 0,
          itemMarginBottom: 20,
          symbolHeight: 14,
          symbolPadding: 12,
          useHTML: true,
          labelFormatter: function() {
            const {
              name,
              visible,
              options: { quantidade }
            } = this;

            return `<div class="cor-fonte medio ${
              visible ? "" : "tipo-vinculo-desativado"
            }"> ${name} <span class="segunda-cor-fonte"> ${Highcharts.numberFormat(
              quantidade,
              0,
              ".",
              "."
            )} </span> </div>`;
          },
          itemHiddenStyle: {
            cursor: "not-allowed",
            color: "#9E9E9E"
          }
        },

        series: [
          {
            center: ["70%", "45%"],
            className: "serie-tipo-rede",
            name: "PTU",
            data: [],

            innerSize: "55%",
            showInLegend: true,
            allowPointSelect: false,
            point: {
              events: {
                click: ev => {
                  const { chave } = ev.point.options;

                  this.selecionarChave(chave);

                  return ev.preventDefault();
                },
                legendItemClick: ev => {
                  const { chave } = ev.target.options;

                  this.selecionarChave(chave);

                  return ev.preventDefault();
                }
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function() {
                const porcentagemFormatado = Highcharts.numberFormat(
                  this.percentage,
                  2
                );
                // if (parseInt(porcentagemFormatado) === 0) return null;
                return porcentagemFormatado + "%";
              },
              connectorShape: "straight",
              distance: 30,
              style: {
                fontWeight: "bold",
                color: "#60656C",
                textOutline: 0
              },
              point: {
                events: {
                  click: ev => {
                    return ev.preventDefault();
                  }
                }
              }
            },
            states: {
              hover: {
                halo: {
                  size: 0
                }
              }
            }
          }
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 400
              },
              chartOptions: {
                legend: {
                  align: "left",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                  floating: false
                },
                chart: {
                  height: "500px"
                },
                series: [
                  {
                    center: [null, "55%"]
                  }
                ]
              }
            }
          ]
        }
      }
    };
  }
};
</script>

<style lang="scss">
.tipo-rede-vinculo {
  cursor: not-allowed;
}

.icone-grafico-vinculo {
  color: #00995d;
  position: absolute;
  z-index: 1;
  left: 31px;
  top: 21px;
}

.serie-tipo-rede > .highcharts-point-inactive {
  cursor: not-allowed !important;
  opacity: 0.2;
}

.highcharts-legend-item > span {
  top: 0px !important;
}

.fade-grafico-vinculo-enter-active,
.fade-grafico-vinculo-leave,
.fade-grafico-vinculo-leave-to {
  transition: opacity 0.25s ease;
}

.fade-grafico-vinculo-enter,
.fade-grafico-vinculo-leave-to {
  opacity: 0;
}
</style>
